<!--
  - Copyright (c) 2022 by 安徽网才信息技术股份有限公司
  -
  - 除非事先获得版权所有人的许可, 禁止以下几项行为:
  - 1. 对该软件的任何源代码和技术文档进行任意形式的打包、分发或复制用于其他目的。
  - 2. 向第三方透露任何与该软件相关的源代码或技术文档。
  - 3. 更改或删除软件或源码中的版权声明。
  -
  -->

<template>
    <div class="m-box clearfix">
        <div class="m-crumb">
            <span class="crumb-span">招聘公告</span> <span class="crumb-span pad-lr-8">⁄</span>
            <a href="" class="crumb-link">公告详情</a>
        </div>
        <div
            v-if="detail.noticeInfo.type === 1 && detail.projectInfo.status === 2 && detail.projectInfo.isOpen"
            class="m-titbox clearfix sticky-filter"
        >
            <div class="fl">
                <div class="title">
                    {{ detail.projectInfo.name }}
                </div>
                <div class="mt-12 info">
                    <i class="ic ic-time"></i>
                    报名时间：{{ detail.projectInfo.applyStartTime }}至{{ detail.projectInfo.applyEndTime }}
                </div>
                <div class=" mt-12 info">
                    <i class="ic ic-org"></i> 招聘单位：{{ detail.projectInfo.sponsor }}
                </div>
            </div>
            <div class="fr mt-48">
                <router-link :to="{name: 'project:detail', query: {id: detail.projectId}}" class="sign-btn">
                    立即报名
                </router-link>
            </div>
        </div>
        <div class="m-article">
            <div class="title">
                {{ detail.noticeInfo.title }}
            </div>
            <div class="right date">
                {{ detail.noticeInfo.onlineAt }}
            </div>
            <div v-html="detail.noticeInfo.content"></div>
            <div class="art-text">
                <div v-show="detail.attachmentList.length" class="art-foot">
                    <span class="block pb-20">附件下载</span>
                    <a v-for="(file, index) in detail.attachmentList" :key="index" :href="file.path" :download="file.name" target="_blank" class="art-footlink block">
                        附件{{ index + 1 }}：{{ file.name }}
                    </a>
                </div>
            </div>
            <div class="m-end">
                <router-link :to="{name: 'notice', query: {type: detail.noticeInfo.type}}" class="sign-btn">
                    返回
                </router-link>
            </div>

            <div v-if="detail.relatedNoticeList.length" class="art-text">
                <div class="art-foot">
                    <span class="block">相关资讯</span>
                    <div class="notice-list">
                        <ul v-if="detail.relatedNoticeList.length" class="m-list">
                            <li v-for="notice in detail.relatedNoticeList" :key="notice.id" class="clearfix">
                                <div class="fl ">
                                    <div class="clearfix lh68">
                                        <i class="u-dot"></i>
                                        <router-link :to="{name: 'notice:detail', query: {id: notice.id}}">
                                            <el-tooltip
                                                class="item"
                                                effect="light"
                                                popper-class="tooltip-wrap"
                                                :content="notice.title"
                                                placement="bottom-end"
                                                :open-delay="1000"
                                            >
                                                <span class="u-text">{{ notice.title }}</span>
                                            </el-tooltip>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="u-date">
                                    {{ notice.onlineAt }}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {noticeDetail} from '@/api/notice';

export default {
    name: 'NoticeDetail',
    data() {
        return {
            queryParam: {
                id: 0,
                code: ''
            },
            detail: {
                projectId: 0,
                isApplied: 0,
                applicationId: 0,
                noticeInfo: {
                    adminId: 0,
                    type: 0,
                    title: '',
                    content: '',
                    onlineAt: '',
                    count: 0
                },
                projectInfo: {
                    id: 0,
                    name: '',
                    applyStartTime: '',
                    applyEndTime: '',
                    sponsor: '',
                    status: 0,
                    isOpen: 0
                },
                attachmentList: [],
                relatedNoticeList: []
            }
        };
    },
    watch: {
        '$route'(to, from){
            if (to.query.id !== from.query.id) {
                this.initData();
            }
        }
    },
    created() {
        this.initData();
    },
    methods: {
        initData() {
            this.queryParam.id = this.$route.query.id ? this.$route.query.id : 0;
            this.queryParam.code = this.$route.query.code ? this.$route.query.code : '';
            if (this.queryParam.id) {
                const loadingInstance = this.$loading({
                    fullscreen: true,
                    text: '加载中',
                    target: document.querySelector('.main')
                });
                this.getNoticeDetail();
                this.$nextTick(() => {
                    loadingInstance.close();
                    // // 在每次路由跳转前，滚动页面到顶部
                    // window.scrollTo(0, 0);
                });
            }
        },
        async getNoticeDetail() {
            const res = await noticeDetail(this.queryParam);
            this.detail = res.data;
            this.detail.relatedNoticeList = this.detail.relatedNoticeList.filter(item => item.id.toString() !== this.queryParam.id.toString());
        }
    }
};
</script>

<style lang="less">
.m-end {
    width: 100%;
    text-align: center;
    margin-top: 20px;
}
.m-end .sign-btn {
    padding: 8px 20px;
    line-height: 24px;
    border-radius: 3px;
    color: #fff;
    font-size: 16px;
    background: #004EA2;
}
.sticky-filter {
    position: sticky;
    top: 0; /* 根据需要调整 */
    z-index: 1000; /* 确保元素在其他内容之上 */
}
.tooltip-wrap {
    padding: 5px !important;
}
.m-end .sign-btn {
    background: var(--themeColor);
}
.m-titbox .sign-btn {
    background: var(--themeColor);
}
</style>
